import React, { ChangeEvent, useEffect, useState } from "react";
import { CheckCircle, Mail, MapPin, TimerReset, UserCircle, X } from "lucide-react";

// Image
import avatar1 from "assets/images/users/avatar-1.png";
import { useDispatch } from "react-redux";
import {
  getUser as onGetUser,
} from 'slices/thunk';
import { Link, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { doGenerateResetPasswordLink } from "../../../services/user.service";

const UserInfo = ({ className }: any) => {
  const dispatch = useDispatch<any>();
  const [selectedImage, setSelectedImage] = React.useState<string | ArrayBuffer | null>(avatar1);
  const { userId } = useParams();

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {

    const file = event.target.files?.[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
    }
  };

  const [user, setUser] = useState<any>([]);

  const handleClickResetPassword = async () => {
    if (!userId) return

    const shortUrl = await doGenerateResetPasswordLink(userId)
    if (!shortUrl) return

    navigator.clipboard.writeText(`${window.location.origin}/${shortUrl.code}`)
    toast.success('Link copied to clipboard', { autoClose: 2000 })
  }

  useEffect(() => {
    (async function () {
      const res = await dispatch(onGetUser(userId as string));
      setUser(res.payload);
    })();
  }, [dispatch, userId]);

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} limit={1} ></ToastContainer>
      {user &&
        <div className={className}>
          <div className="grid grid-cols-1 gap-5 lg:grid-cols-12 2xl:grid-cols-12">
            <div className="lg:col-span-2 2xl:col-span-1">
              <div className="relative inline-block w-20 h-20 rounded-full shadow-md bg-slate-100 profile-user xl:w-28 xl:h-28">
                <img src={selectedImage?.toString() ?? avatar1} alt="" className="object-cover border-0 rounded-full img-thumbnail user-profile-image" />
                <div className="absolute bottom-0 flex items-center justify-center w-8 h-8 rounded-full ltr:right-0 rtl:left-0 profile-photo-edit">
                  <input id="profile-img-file-input" type="file"
                    className="hidden profile-img-file-input"
                    onChange={handleImageChange} />
                  {/* <label htmlFor="profile-img-file-input" className="flex items-center justify-center w-8 h-8 bg-white rounded-full shadow-lg cursor-pointer dark:bg-zink-600 profile-photo-edit">
                    <ImagePlus className="w-4 h-4 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-500"></ImagePlus>
                  </label> */}
                </div>
              </div>
            </div>
            <div className="lg:col-span-10 2xl:col-span-9">
              <h5 className="mb-1">{user?.name}&nbsp;
                {user?.status === 'active' &&
                  <span className="px-2.5 py-0.5 text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent inline-flex items-center status"><CheckCircle className="w-3 h-3 mr-1.5" />{user.status}</span>
                }
                {user?.status === 'inactive' &&
                  <span className="px-2.5 py-0.5 inline-flex items-center text-xs font-medium rounded border bg-red-100 border-transparent text-red-500 dark:bg-red-500/20 dark:border-transparent status"><X className="w-3 h-3 mr-1.5" />{user.status}</span>
                }
              </h5>
              <div className="flex gap-3 mb-4">
                <p className="text-slate-500 dark:text-zink-200"><UserCircle className="inline-block w-4 h-4 ltr:mr-1 rtl:ml-1 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-500"></UserCircle> {user.role}</p>
                <p className="text-slate-500 dark:text-zink-200"><MapPin className="inline-block w-4 h-4 ltr:mr-1 rtl:ml-1 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-500"></MapPin> {user.country} {user.address && `- ${user.address}`}</p>
              </div>
              <p className="mt-4 text-slate-500 dark:text-zink-200">Strong leader and negotiator adept at driving collaboration and innovation. Highly accomplished CEO & Founder with 10+ years of experience creating, launching and leading successful business ventures. Proven ability to build relationships, drive customer loyalty and increase profitability.</p>
            </div>
            <div className="lg:col-span-12 2xl:col-span-2">
              <div className="grid grid-cols-1 gap-5 lg:grid-cols-12 2xl:grid-cols-12">
                <div className="flex gap-2 2xl:justify-end">
                  <a href={`mailto:${user.email}`} className="flex items-center justify-center w-[37.5px] h-[37.5px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20">
                    <Mail className="w-4 h-4"></Mail>
                  </a>
                </div>
                <div className="flex gap-2 2xl:justify-end">
                  <Link to="#" onClick={() => {
                    handleClickResetPassword()
                  }} className="flex items-center justify-center w-[37.5px] h-[37.5px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20">
                    <TimerReset className="w-4 h-4"></TimerReset>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </React.Fragment >
  );
}

export default UserInfo;